import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Input, Button } from 'loyal-react'

const numberPattern = /^[0-9]*$/

class Form extends Component {
  state = {
    zipCode: this.props.zipCode.value,
    receiver: this.props.receiver.value,
    number: this.props.number.value,
    complement: this.props.complement.value
  }

  handleZipCodeChange = event => {
    const zipCode = event.target.value
    this.setState({ zipCode })
    const zipCodeNumber = zipCode.replace('-', '')
    if (zipCodeNumber.length === 8 && numberPattern.test(zipCodeNumber)) {
      this.props.fetchShipping(zipCodeNumber)
    }
  }

  handleOnClick = _ =>
    this.props.btn.onClick({
      zipCode: this.state.zipCode.value,
      receiver: this.state.receiver.value,
      number: this.state.number.value,
      complement: this.state.complement.value
    })

  render () {
    return (
      <div className='address-form col-12 mt-1 px-2'>
        <div className='row'>
          <Input
            id='address-zipCode'
            label='CEP'
            className='col-12 col-md-6 mt-2'
            value={this.state.zipCode}
            onChange={this.handleZipCodeChange}
            mask={[/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/]}
            required
            disabled={this.props.zipCode.disabled}
          />
          <Input
            id='address-receiver'
            label='Destinatário'
            className='col-12 col-md-6  mt-2'
            value={this.state.receiver}
            onChange={e => this.setState({ receiver: e.target.value })}
            required
            disabled={this.props.receiver.disabled}
          />
          <Input
            id='address-street'
            label='Logradouro'
            className='col-12 col-md-6 mt-2'
            value={this.props.street.value}
            required
            disabled='true'
          />
          <Input
            id='address-number'
            label='Número'
            className='col-12 col-md-6 mt-2'
            value={this.state.number}
            onChange={e => this.setState({ number: e.target.value })}
            required
            disabled={this.props.number.disabled}
          />
          <Input
            id='address-complement'
            label='Complemento'
            className='col-12 col-md-6 mt-2'
            value={this.state.complement}
            onChange={e => this.setState({ complement: e.target.value })}
            disabled={this.props.complement.disabled}
          />
          <Input
            id='address-district'
            label='Bairro'
            className='col-12 col-md-6 mt-2'
            value={this.props.district.value}
            required
            disabled='true'
          />
          <Input
            id='address-city'
            label='Cidade'
            className='col-12 col-md-6 mt-2'
            value={this.props.city.value}
            required
            disabled='true'
          />
          <Input
            id='address-state'
            label='Estado'
            className='col-12 col-md-6 mt-2'
            value={this.props.state.value}
            required
            disabled='true'
          />
          <div className='col-12 offset-md-6 col-md-6 mt-1 mb-2 pb-1 px-1 py-1'>
            <Button
              id={'btn-address-submit'}
              className='btn-featured form-field btn-sm txt-center'
              text={this.props.btn.text}
              onClick={this.handleOnClick}
            />
          </div>
        </div>
      </div>
    )
  }
}

const valueType = PropTypes.shape({
  value: PropTypes.string.isRequired,
  disabled: PropTypes.string.isRequired
})

const btnType = PropTypes.shape({
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired
})

Form.propTypes = {
  street: valueType.isRequired,
  district: valueType.isRequired,
  city: valueType.isRequired,
  state: valueType.isRequired,
  zipCode: valueType.isRequired,
  receiver: valueType,
  number: valueType,
  complement: valueType,
  btn: btnType.isRequired,
  fetchShipping: PropTypes.func.isRequired
}

export default Form



// WEBPACK FOOTER //
// ./src/features/Address/Form.js